<template>
  <div id="app">
    <app-header v-if="showHeader" />
    <main class="content-area" :class="{ 'with-header': showHeader }">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from './components/Header.vue';

const route = useRoute();

// 로그인 페이지에서는 헤더를 표시하지 않음
const showHeader = computed(() => {
  return route.name !== 'Login';
});
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: 'Noto Sans KR', sans-serif;
  overflow-x: hidden;
}

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-area {
  flex: 1;
  overflow-y: auto;
}

.content-area.with-header {
  padding-top: 50px;
  height: calc(100vh - 50px);
}
</style>